import { render } from "./initTable.vue?vue&type=template&id=ca8993bc&scoped=true"
import script from "./initTable.vue?vue&type=script&lang=js"
export * from "./initTable.vue?vue&type=script&lang=js"

import "./initTable.vue?vue&type=style&index=0&id=ca8993bc&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8993bc"]])

export default __exports__